/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Button from 'antd/es/button';
import Row from 'antd/es/row';
import Col from 'antd/es/col';
import Typography from 'antd/es/typography';
import Space from 'antd/es/space';
import Divider from 'antd/es/divider';
import Radio from 'antd/es/radio';
import Card from 'antd/es/card';
import Form from 'antd/es/form';
import Select from 'antd/es/select';
import Input from 'antd/es/input';
import InputNumber from 'antd/es/input-number';
import Modal from 'antd/es/modal';
import Image from 'antd/es/image';
import message from 'antd/es/message';
import Progress from 'antd/es/progress';
import { SendOutlined, SaveOutlined, PlusOutlined, FormOutlined, CloudUploadOutlined } from '@ant-design/icons';
import { format } from 'date-fns';
import './AssessmentTools.css';
import SimpleBarReact from "simplebar-react";
import uuid from 'react-uuid';
import Wysiwyg2 from '../wysiwyg/wysiwyg2';
import StickyBox from "react-sticky-box";
import FloatingActionButton from '../floating-button/FloatingActionButton';
import { Grid } from 'antd';
import { SchoolTerms, Levels } from '../../constants';
import WysiwygMathEditor from '../wysiwyg/WysiwygMathEditor';

const { Title, Text, Paragraph } = Typography;
const { Option } = Select;
// const SectionSvg = () => (
//    // <svg width="1em" height="1em" fill="currentColor" viewBox="64 64 896 896">
//    //   <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/>
//    // </svg>
//    <svg viewBox="0 0 24 24" focusable="false" width="1em" height="1em" fill="currentColor" aria-hidden="true">
//       <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" />
//    </svg>
// );

// const SectionIcon = props => <Icon component={SectionSvg} {...props} />;

export default function AssessmentTool(props) {
   const [form] = Form.useForm();

   const screens = Grid.useBreakpoint();
   const isMobile = !screens.md; // treat < md as mobile

   // PDF upload state (used by floating button action)
   const pdfFileInputRef = useRef(null);
   const [percentage, setPercentage] = React.useState(0);
   const [isUploading, setIsUploading] = React.useState(false);

   // This component is used by multiple pages. Some pass assessment info with
   // camelCase keys (title/level/subject/term/...) while others still use
   // PascalCase (Title/Level/Subject/Term/...). Normalize once to avoid bugs
   // (e.g. subject not restoring from localStorage).
   const normalizedData = React.useMemo(() => {
      const d = props.data || {};
      return {
         title: d.title ?? d.Title ?? '',
         date_created: d.date_created ?? d.Date_created ?? '',
         level: d.level ?? d.Level ?? null,
         subject: d.subject ?? d.Subject ?? null,
         term: d.term ?? d.Term ?? null,
         instruction: d.instruction ?? d.Instruction ?? null,
      };
   }, [props.data]);

   const [editableTitle, setEditableTitle] = useState(normalizedData.title);
   const [assDate, setAssDate] = useState(
      props.mode === "create"
         ? format(new Date(), 'MMM. dd, yyyy h:mm a') + ""
         : normalizedData.date_created
   );
   const [assLevel, setAssLevel] = useState(normalizedData.level);
   const [assSubject, setAssSubject] = useState(normalizedData.subject);
   const [questionTemplate, setQuestionTemplate] = useState(1);
   const [createType, setCreateType] = useState('manual');
   const [topic, setTopic] = useState(null);
   const [noi, setNOI] = useState(1);
   const [toq, setTOQ] = useState(['questions with short answer (should be one to two words only)']);
   const [lod, setLOD] = useState('easy');
   const [language, setLanguage] = useState('english');
   const [generating, setGenerating] = React.useState(false);
   const [visibleAI, setVisibleAI] = useState(false);
   const [instruction, setInstruction] = useState(normalizedData.instruction !== undefined ? normalizedData.instruction : null);
   const [visibleAnswerKeys, setVisibleAnswerKeys] = useState(false);
   const [visibleAssessmentDetails, setVisibleAssessmentDetails] = useState(false);

   const [subjectList, setSubjectList] = useState([]);
   const [assTerm, setAssTerm] = useState(normalizedData.term);

   // --- Dirty tracking + auto-save on leave/unload (edit mode) ---
   // Goal: If user edited assessment details/questions and leaves without saving,
   // we trigger a best-effort save.
   const lastSavedSnapshotRef = useRef('');
   const hasUnsavedChangesRef = useRef(false);
   const savingOnLeaveRef = useRef(false);
   const currentAssessmentIdRef = useRef(null);
   const autoSaveBeforeLeaveRef = useRef(null);

   const isEditMode = props.mode?.toLowerCase?.() === 'edit';

   useEffect(() => {
      // const unloadCallback = (event) => {
      // //   event.preventDefault();
      // //   event.returnValue = "";
      // // localStorage.clear();
      //   return "";
      // };

      // window.addEventListener("beforeunload", unloadCallback);
      // return () => window.removeEventListener("beforeunload", unloadCallback);
      // getLookUps();
      // NOTE: subject list is loaded async. We must NOT overwrite the current
      // subject with an undefined property (this was causing “subject not
      // restored from localStorage”).

      // If level isn't selected yet, don't fetch subjects.
      if (!normalizedData.level) return;

      axios.get(`${process.env.REACT_APP_API_LOOKUP}/subjectlist?level=${normalizedData.level}&school_year=16`).then((response) => {
         if (response.data) {
            const data = response.data;
            var slist = [];
            data.map((item) => {
               let obj = { 'value': item.value, 'name': item.name }
               slist.push(obj);
            });

            setSubjectList(slist);

            // Prefer the current state (e.g. from localStorage) and only fall
            // back to incoming props value if state is empty.
            setAssSubject((prev) => prev ?? normalizedData.subject);
         }
      }, (error) => {
         console.log(error.message);
      });
   }, []);

   const handleLevelChange = (val) => {
      setAssLevel(val);
      setAssSubject(null);

      var slist = [];
      axios.get(`${process.env.REACT_APP_API_LOOKUP}/subjectlist?level=${val}&school_year=16`).then((response) => {
         if (response.data) {
            const data = response.data;

            data.map((item) => {
               let obj = { 'value': item.value, 'name': item.name }
               slist.push(obj);
            });

            setSubjectList(slist);
         }
      }, (error) => {
         console.log(error.message);
      });
   }

   const handleCardRequest = (method, type, data, idx) => {
      props.cardRequestCallback(method, type, data, idx, questionTemplate);
   }

   const computeSnapshot = React.useCallback(() => {
      // Include both local assessment info (title/level/subject/term/instruction)
      // and questions sheet / file url if the parent provides it in props.data.
      const questionSheet = props?.data?.Question_sheet ?? props?.data?.question_sheet;
      const fileUrl = props?.data?.file_url ?? props?.data?.File_url ?? null;

      return JSON.stringify({
         title: editableTitle ?? '',
         term: assTerm ?? null,
         date: assDate ?? '',
         level: assLevel ?? null,
         subject: assSubject ?? null,
         instruction: instruction ?? null,
         fileUrl,
         questionSheet: questionSheet ?? null,
      });
   }, [props?.data, editableTitle, assTerm, assDate, assLevel, assSubject, instruction]);

   const markSavedSnapshot = React.useCallback(() => {
      lastSavedSnapshotRef.current = computeSnapshot();
      hasUnsavedChangesRef.current = false;
   }, [computeSnapshot]);

   const handleSave = React.useCallback(() => {
      var assInfo = {
         title: editableTitle,
         term: assTerm,
         date: assDate,
         level: assLevel,
         subject: assSubject,
         instruction
      }

      props.saveCallback(assInfo);

      // After an explicit save, consider current state as the new baseline.
      // Note: saveCallback may be async; this is a pragmatic best-effort.
      markSavedSnapshot();
   }, [props.saveCallback, editableTitle, assTerm, assDate, assLevel, assSubject, instruction, markSavedSnapshot]);

   // Initialize the baseline snapshot when entering edit mode (or when a new
   // assessment is loaded).
   useEffect(() => {
      if (!isEditMode) return;

      const incomingId = props?.data?.Id ?? props?.data?.id ?? null;
      if (currentAssessmentIdRef.current !== incomingId) {
         currentAssessmentIdRef.current = incomingId;
         // Reset baselines when switching assessments (defensive)
         lastSavedSnapshotRef.current = '';
         hasUnsavedChangesRef.current = false;
         savingOnLeaveRef.current = false;
      }

      // If we already have a baseline, keep it (prevents overwriting baseline
      // during edits).
      if (lastSavedSnapshotRef.current) return;
      markSavedSnapshot();
   }, [isEditMode, props?.data?.Id, props?.data?.id, markSavedSnapshot]);

   // Update dirty flag whenever relevant inputs change.
   useEffect(() => {
      if (!isEditMode) return;
      if (!lastSavedSnapshotRef.current) {
         // Baseline might not be initialized yet.
         lastSavedSnapshotRef.current = computeSnapshot();
         hasUnsavedChangesRef.current = false;
         return;
      }

      const snapshot = computeSnapshot();
      hasUnsavedChangesRef.current = snapshot !== lastSavedSnapshotRef.current;
   }, [isEditMode, computeSnapshot]);

   const autoSaveBeforeLeave = React.useCallback(() => {
      if (!isEditMode) return;
      if (!hasUnsavedChangesRef.current) return;
      if (savingOnLeaveRef.current) return;

      savingOnLeaveRef.current = true;
      try {
         // Best-effort: trigger the same save path used by the Save button.
         handleSave();

         // Inform the user (works reliably for in-app navigation/unmount).
         // Note: On real tab close/refresh, browsers may not render UI.
         message.success('Assessment has been automatically saved.');
      } catch (e) {
         // swallow - leaving/unloading shouldn't crash
      } finally {
         // keep flag set; prevents duplicate calls during the same leave.
      }
   }, [isEditMode, handleSave]);

   // Keep latest auto-save function in a ref so our unmount/beforeunload hooks
   // don't re-run (and call cleanup) on every keystroke/state change.
   useEffect(() => {
      autoSaveBeforeLeaveRef.current = autoSaveBeforeLeave;
   }, [autoSaveBeforeLeave]);

   // Save on browser refresh/close (best-effort)
   useEffect(() => {
      if (!isEditMode) return;

      // const handleBeforeUnload = (e) => {
      //    if (!hasUnsavedChangesRef.current) return;
      //    autoSaveBeforeLeaveRef.current?.();
      //    // NOTE: We are not blocking unload with a confirm prompt.
      //    // Requirement is to save automatically.
      // };

      // window.addEventListener('beforeunload', handleBeforeUnload);
      // return () => window.removeEventListener('beforeunload', handleBeforeUnload);

      const handlePageHide = () => {
         if (!hasUnsavedChangesRef.current) return;
         autoSaveBeforeLeaveRef.current?.();
      };

      window.addEventListener('pagehide', handlePageHide);
      return () => window.removeEventListener('pagehide', handlePageHide);
   }, [isEditMode]);

   // Save when leaving via in-app navigation (component unmount)
   useEffect(() => {
      if (!isEditMode) return;
      return () => {
         autoSaveBeforeLeaveRef.current?.();
      };
   }, [isEditMode]);

   // // pagehide is more reliable than beforeunload on mobile Safari.
   // useEffect(() => {
   //    if (!isEditMode) return;

   //    const handlePageHide = () => {
   //       if (!hasUnsavedChangesRef.current) return;
   //       saveToServerOnUnload();
   //    };

   //    window.addEventListener('pagehide', handlePageHide);
   //    return () => window.removeEventListener('pagehide', handlePageHide);
   // }, [isEditMode, saveToServerOnUnload]);

   const handleTemplateChange = (e) => {
      setQuestionTemplate(e.target.value);
   }

   function buildPrompt() {
      let retVal = "";

      retVal = `Create a test on ${assSubject} for ${assLevel} students with the following conditions:\n
                - The topic is about ${topic}.\n
                - Number of questions should be exactly ${noi} items.\n
                - Type of questions are ${toq.join()}.\n
                - Difficulty level is ${lod}.\n
                - Keep language level suitable for ${assLevel} students.\n
                - Translate the language to ${language}.\n
                - Provide the questions and the exact correct answers then convert the result into a valid json string strictly using this format [{ "Question": "", "Type": "", "Choices": [""], "Correct Answer": ""},].\n
                - Make sure the json string is valid and can be parsed.
                - Make sure the "Correct Answer" field contains the exact answer only and nothing else.
                - If the question type is True or False, make sure the "Choices" field contains only "True" and "False".
                - If the question type is Multiple Choice or Multiple Answer, make sure the "Choices" field contains at least 4 choices including the correct answer.
                - If the question type is Short Answer, make sure the "Choices" field is empty.
                - Do not include any other information or notes outside the json string.
                - Make sure that Multiple Choice questions have only one correct answer and Multiple Answer questions have more than one correct answer.`;

      return retVal;
   }

   const handleGenerateAssessment = async () => {
      setGenerating(true);

      props.generateCardsFromAI([]);
      var newQuestion = buildPrompt();

      var tmpMessage = [];
      tmpMessage.push({ "role": "user", "content": newQuestion });
      tmpMessage.push({ "role": "system", "content": "You are an expert in creating assessments" });

      function questionType(val, correct) {
         var retVal = '';

         switch (val.toLowerCase()) {
            case 'short answer':
               retVal = 'short_answer';
               break;

            case 'multiple answer':
            case 'multiple choice':
               retVal = 'multiple_choice';

               if (Array.isArray(correct))
                  if (correct.length > 1)
                     retVal = 'multiple_answer';
               break;

            case 'true or false':
            case 'true/false':
               retVal = 'true_or_false';
               break;
            default:
               retVal = '';
         }

         return retVal;
      }

      function generateCorrectAnswer(type, correct, choices) {
         var retVal = null;

         switch (type) {
            case 'short_answer':
               retVal = correct.split();
               break;
            case 'true_or_false':
            case 'multiple_choice':
            case 'multiple_answer':
               var c = [];

               for (var i = 0; i < choices.length; i++) {
                  c.push('0');
               }

               if (Array.isArray(correct)) {
                  correct.forEach(function (itm, idx) {
                     choices.forEach(function (item, index) {
                        if (item === itm)
                           c[index] = '1';
                     });
                  });
               }
               else {
                  choices.forEach(function (item, index) {
                     if (item === correct)
                        c[index] = '1';
                  });
               }

               retVal = c;
               break;
            default:
               retVal = '';
         }

         return retVal;
      }

      try {
         // const response = await openai.createChatCompletion({
         //    // model: "gpt-3.5-turbo-0125",
         //    // model: "gpt-4",
         //    // model: "gpt-4o-2024-08-06",
         //    model: "gpt-4o-2024-11-20",
         //    // model: "gpt-4o-mini-2024-07-18",
         //    max_tokens: 5000,
         //    temperature: 0.5,
         //    // top_p: 1,
         //    messages: tmpMessage,
         //    n: 1,
         //    stream: false,
         // });


         var url = `${process.env.REACT_APP_API_CPH}/openai`;
         const response = await axios.post(url, {
            // model: "gpt-4o-2024-11-20",
            model: "gpt-4.1-2025-04-14",
            max_tokens: 10000,
            temperature: 0.5,
            messages: tmpMessage
         });


         // const response = await fetch("https://api.openai.com/v1/chat/completions", {
         // const response = await axios.post("https://api.openai.com/v1/chat/completions",
         //    // method: "POST",
         //    {
         //       model: "gpt-4o-2024-11-20",
         //       max_tokens: 5000,
         //       temperature: 0.5,
         //       messages: tmpMessage,
         //    },
         //    {
         //       headers: {
         //          "Content-Type": "application/json",
         //          Authorization: `Bearer ${configuration.apiKey}`,
         //       },
         //    }
         // );

         // const data = await response.json();
         // const reply = data.choices?.[0]?.message?.content || "No response";

         if (response.data.choices) {
            let result = response.data.choices[0].message?.content.trim();

            result = result.replace(/\n/g, '');
            result = result.replace(/```/g, '');
            result = result.replace('json', '');
            var tmpQuestions = JSON.parse(result);

            var formattedQuestions = [];

            tmpQuestions.forEach((e) => {
               var questionTemplate = {
                  id: '',
                  type: '',
                  correct: [''],
                  points: '1',
                  question: '',
                  option_labels: '',
                  template: '1',
               }

               try {
                  questionTemplate.id = uuid();
                  questionTemplate.type = questionType(e.Type, e['Correct Answer']);
                  questionTemplate.question = e.Question;
                  questionTemplate.correct = generateCorrectAnswer(questionTemplate.type, e['Correct Answer'], ['true_or_false', 'true or false', 'true/false'].includes(e.Type.toLowerCase()) ? ['True', 'False'] : (e.Choices.length > 0 ? e.Choices : ''));
                  questionTemplate.option_labels = ['true_or_false', 'true or false', 'true/false'].includes(e.Type.toLowerCase()) ? ['True', 'False'] : (e.Choices.length > 0 ? e.Choices : '');

                  if (questionTemplate.correct.length > 0)
                     formattedQuestions.push(questionTemplate);
               }
               catch (ex) {
                  console.log(ex);
               }

            });

            props.generateCardsFromAI(formattedQuestions);
         }

         setGenerating(false);
         setVisibleAI(false);
      }
      catch (ex) {
         console.log(ex);
         message.warning("There was a problem generating the assessment. Please try again.");
         setGenerating(false);
      }
   }

   const onFinish = (values) => {
      console.log('Success:', values);
      handleGenerateAssessment();
   };

   const onFinishFailed = (errorInfo) => {
      console.log('Failed:', errorInfo);
   };

   const handleShowAI = () => {
      setVisibleAI(true);
   }

   // const handleChangeInstruction = (val) => {
   //    setInstruction(val);
   // }

   // const templateOptions = [
   //    { value: 1, img: 'q_text.png', label: 'TEXT' },
   //    { value: 2, img: 'q_image.png', label: 'IMAGE' },
   //    { value: 3, img: 'q_text_image.png', label: 'TEXT & IMAGE' },
   //    { value: 4, img: 'q_audio.png', label: 'AUDIO' },
   //    { value: 6, img: 'text_audio.png', label: 'TEXT & AUDIO' },
   //    { value: 5, img: 'q_audio.png', label: 'VIDEO' },
   //    { value: 7, img: 'text_video.png', label: 'TEXT & VIDEO' },
   // ];

   // const TemplateRadio = ({ value, img, label, selected }) => (
   //    <Col sm={24} md={8} lg={8}>
   //       <Radio value={value}>
   //          <Space direction="vertical" size="small">
   //             <img
   //                src={`../images/${img}`}
   //                style={{
   //                   width: "100px",
   //                   height: "100px",
   //                   border: selected === value ? '3px solid #ccc' : '1px solid #ccc'
   //                }}
   //                alt={label}
   //             />
   //             <Text>{label}</Text>
   //          </Space>
   //       </Radio>
   //    </Col>
   // );

   // const TemplateSelector = ({ questionTemplate, handleTemplateChange }) => (
   //    <Row>
   //       <Col span={24}>
   //          <Radio.Group
   //             defaultValue={1}
   //             buttonStyle="solid"
   //             onChange={handleTemplateChange}
   //          >
   //             <Row gutter={6}>
   //                {templateOptions.map(option => (
   //                   <TemplateRadio
   //                      key={option.value}
   //                      value={option.value}
   //                      img={option.img}
   //                      label={option.label}
   //                      selected={questionTemplate}
   //                   />
   //                ))}
   //             </Row>
   //          </Radio.Group>
   //       </Col>
   //    </Row>
   // );

   const RenderTemplateSelector = () => {
      const templates = [
         { value: 1, label: "TEXT", image: "../images/q_text.png" },
         { value: 2, label: "IMAGE", image: "../images/q_image.png" },
         { value: 3, label: "TEXT & IMAGE", image: "../images/q_text_image.png" },
         { value: 4, label: "AUDIO", image: "../images/q_audio.png" },
         { value: 5, label: "TEXT & AUDIO", image: "../images/text_audio.png" },
         { value: 6, label: "VIDEO", image: "../images/q_audio.png" },
         { value: 7, label: "TEXT & VIDEO", image: "../images/text_video.png" },
      ];

      return (
         <Card style={{ backgroundColor: "#e0ecff", margin: "10px" }}>
            <Row justify="center">
               <Col span={24}>
                  <Radio.Group
                     defaultValue={1}
                     buttonStyle="solid"
                     onChange={handleTemplateChange}
                     style={{ display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "center" }}
                  >
                     {templates.map(({ value, label, image }) => (
                        <Radio key={value} value={value}>
                           <Space direction="vertical" size="small" align="center">
                              <img
                                 src={image}
                                 style={{
                                    width: "85px",
                                    height: "85px",
                                    border: questionTemplate === value ? "3px solid #ccc" : "1px solid #ccc",
                                 }}
                                 alt={label}
                              />
                              <Text>{label}</Text>
                           </Space>
                        </Radio>
                     ))}
                  </Radio.Group>
               </Col>
            </Row>
         </Card>
      )
   }
   
   const RenderQuestionType = () => {
      const cardTypes = [
         { type: "section", label: "Section", image: "../images/section.png" },
         { type: "short_answer", label: "Short Answer", image: "../images/short_answer.png" },
         { type: "true_or_false", label: "True or False", image: "../images/true_or_false.png" },
         { type: "long_answer", label: "Open-ended/Essay", image: "../images/essay.png" },
         { type: "multiple_choice", label: "Multiple Choice", image: "../images/multiple_choice.png" },
         { type: "multiple_choice_image", label: "Multiple Choice - Image", image: "../images/multiple_choice_image.png" },
         { type: "multiple_answer", label: "Multiple Answer", image: "../images/multiple_answer.png" },
         { type: "multiple_answer_image", label: "Multiple Answer - Image", image: "../images/multiple_answer_image.png" },
         { type: "matching_type", label: "Matching Type", image: "../images/matching_type.png" },
         { type: "matching_type_image", label: "Matching Type - Image", image: "../images/matching_type_image.png" },
      ];

      return (
         <Row justify="center">
            <Col span={24}>
               <div style={{ display: "flex", flexWrap: "wrap", gap: "15px", justifyContent: "center", textAlign: "center" }}>
                  {cardTypes.map(({ type, label, image }) => (
                     <div key={type} onClick={() => handleCardRequest("add", type, 0)}>
                        <Card
                           hoverable
                           style={{
                              backgroundColor: "#d0e2fe",
                              height: '121px', 
                              maxWidth: '202px',
                              padding: "0px",
                           }}
                        >
                           <Text>{label}</Text>
                           <img src={image} alt={label} />
                        </Card>
                     </div>
                  ))}
               </div>
            </Col>
         </Row>
      );
   }

   const persistDraft = React.useCallback((overrides = {}) => {
      if (!props.updateInfoCallback) return;

      // Prefer PascalCase to match existing diagnostic draft objects,
      // but restoration remains resilient because we normalize on read.
      props.updateInfoCallback({
         ...(props.data || {}),
         title: editableTitle,
         date_created: assDate,
         level: assLevel,
         subject: assSubject,
         term: assTerm,
         instruction: instruction,
         ...overrides,
      });
   }, [props.updateInfoCallback, props.data, editableTitle, assDate, assLevel, assSubject, assTerm, instruction]);

   const handleUpdateInfo = () => {
      persistDraft();
   }

   const handleUploadQuestions = () => {
      // Prefer the new internal uploader (hidden file input) so the floating
      // button can open the file picker.
      if (pdfFileInputRef.current) {
         pdfFileInputRef.current.value = '';
         pdfFileInputRef.current.click();
         return;
      }

      // Legacy fallback (some pages used to pass a callback)
      if (props.uploadQuestionsCallback) props.uploadQuestionsCallback();
   }

   const uploadPdfToS3 = (file) => {
      const formData = new FormData();
      formData.append('file', file);

      setPercentage(0);
      setIsUploading(true);

      const url = `${process.env.REACT_APP_API_S3_UPLOAD}/uploadASSFile?s3path=${process.env.REACT_APP_S3_ASSESSMENT_QUESTIONAIRE_PATH}`;

      axios
         .post(url, formData, {
            onUploadProgress: (progressEvent) => {
               const { loaded, total } = progressEvent;
               if (!total) return;
               setPercentage(Math.floor((loaded * 100) / total));
            },
         })
         .then((response) => {
            const uploadedKey = response?.data;
            if (!uploadedKey) {
               message.error('Upload failed: server did not return a file key.');
               return;
            }

            // Push the uploaded PDF key/url back to the parent page.
            // Use both file_url + File_url to stay compatible with pages that
            // still use PascalCase.
            if (props.updateInfoCallback) {
               props.updateInfoCallback({
                  ...(props.data || {}),
                  file_url: uploadedKey,
                  File_url: uploadedKey,
               });
            }
         })
         .catch((error) => {
            console.log(error?.message || error);
            message.error('Upload failed. Please try again.');
         })
         .finally(() => {
            setIsUploading(false);
         });
   };

   const handlePdfInputChange = (e) => {
      const file = e.target.files?.[0];
      if (!file) return;

      const isPDF = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
      if (!isPDF) {
         message.error(`${file.name} is not a pdf file`);
         return;
      }

      uploadPdfToS3(file);
   };

   const menuItems = [      
      { id: 4, label: <SaveOutlined />, onClick: () => handleSave(), toolTipMsg: `Step ${props.type === 'pdf' ? "4" : "5"} - Save Assessment` },
      { id: 3, label: <PlusOutlined />, onClick: () => setVisibleAnswerKeys(true), toolTipMsg: `${props.type === 'pdf' ? "Step 3 - Add New Answer Keys" : "Step 4 - Add New Questions"}` },
      { id: 2, label: <CloudUploadOutlined />, onClick: () => handleUploadQuestions(true), toolTipMsg: `Step 2 - Upload Questions` },
      { id: 1, label: <FormOutlined />, onClick: () => setVisibleAssessmentDetails(true), toolTipMsg: `Step 1 - Assessment Information` },
   ];

   return (
      <div>
         {
            (!props.mode.includes("assign") && props.mode !== "view") &&
            <>
               {/* Hidden file input used by the floating action button (PDF pages) */}
               {props.type === 'pdf' && (
                  <input
                     ref={pdfFileInputRef}
                     type="file"
                     accept=".pdf,application/pdf"
                     style={{ display: 'none' }}
                     onChange={handlePdfInputChange}
                  />
               )}

               {/* {props.type === 'pdf' && (
                  <FloatingActionButton menuItems={menuItems} />
               )} */}

               {
                  props.showToggle === true && props.type === 'pdf' &&
                  <div className='button-selection-toggle-container' style={{ display: "flex", gap: "10px" }}>
                     <Button className='button-shadow' type='primary' block shape='round' onClick={() => setVisibleAssessmentDetails(true)}>
                        <Text ellipsis style={{ color: "#fff" }}>Assessment Info</Text>
                     </Button>
                     <Button className='button-shadow' type='primary' block shape='round' onClick={() => setVisibleAnswerKeys(true)}>
                        <Text ellipsis style={{ color: "#fff" }}>Question Type</Text>
                     </Button>
                  </div>
               }
               {
                  props.mode === "create" && props.type === 'manual' &&
                  <StickyBox style={{ zIndex: 1000 }}>
                     <Space className='button-shadow' style={{ cursor: 'pointer', padding: '15px', borderRadius: '32px', marginBottom: "10px", backgroundColor: "#FFFFFF" }} onClick={() => handleShowAI()}>
                        <Image src='../images/brainee_bot.png' preview={false} height="30px" style={{ cursor: 'pointer' }} />
                        <Text style={{ fontSize: '16px', cursor: 'pointer', color: '#a3a3ac' }}>Allow me to assist you</Text>
                     </Space>
                  </StickyBox>
               }
               {
                  createType === 'manual'
                     ?
                     <>
                        {
                           (props.type === 'manual') &&
                           <>
                              <Divider orientation="center">
                                 <Title level={5} style={{ textAlign: "Left", color: "#a3a3ac" }}>Instruction</Title>
                              </Divider>

                              <div style={{ marginBottom: "15px", paddingLeft: 5, paddingRight: 5 }}>
                                 {/* <Wysiwyg2
                                    id={props.id}
                                    content={instruction}
                                    height={300}
                                    contentHeight={225}
                                    updateOnChange={true}
                                    changeContentCallback={(content) => {
                                       setInstruction(content);
                                       // Persist instruction drafts immediately so refresh/navigation retains edits
                                       // even if the editor doesn't trigger the wrapper's onBlur.
                                       persistDraft({ instruction: content });
                                    }}
                                 /> */}
                                 <WysiwygMathEditor
                                    id={props.id}
                                    content={instruction}
                                    height={300}
                                    // contentHeight={225}
                                    updateOnChange={true}
                                    changeContentCallback={(content) => {
                                       setInstruction(content);
                                       // Persist instruction drafts immediately so refresh/navigation retains edits
                                       // even if the editor doesn't trigger the wrapper's onBlur.
                                       persistDraft({ instruction: content });
                                    }}
                                 />
                              </div>

                              <Divider orientation="center">
                                 <Title level={5} style={{ textAlign: "Left", color: "#a3a3ac" }}>Question Template</Title>
                              </Divider>

                              {RenderTemplateSelector()}
                           </>
                        }
                        {
                           (props.type === 'pdf')
                              ?
                              <div className='button-selection-toggle-container' style={{ display: "flex", gap: "10px" }}>
                                 <Button className='button-shadow' type='primary' block shape='round' onClick={() => handleUploadQuestions(true)}>
                                    <Text ellipsis style={{ color: "#fff" }}>Upload Questions</Text>
                                 </Button>
                                 <Button className='button-shadow' type='primary' block shape='round' onClick={() => handleSave(true)}>
                                    <Text ellipsis style={{ color: "#fff" }}>Save</Text>
                                 </Button>
                              </div>
                              :
                              <div style={{ padding: '20px' }}>
                                 <Divider orientation="center">
                                    <Title level={5} style={{ textAlign: "Left", color: "#a3a3ac" }}>Question Type</Title>
                                 </Divider>

                                 {RenderQuestionType()}

                                 <Divider orientation="center">
                                    <Title level={5} style={{ textAlign: "Left", color: "#a3a3ac" }}>Save Assessment</Title>
                                 </Divider>

                                 <Row style={{ paddingBottom: 12 }}>
                                    <Col span={24} className="gutter-row">
                                       <Button className='button-shadow' type='primary' block shape='round' style={{ fontSize: 12 }} onClick={() => handleSave()}><Text ellipsis style={{ color: "#fff" }}><SaveOutlined />&nbsp;Save</Text></Button>
                                    </Col>
                                 </Row>
                              </div>
                        }
                     </>
                     :
                     <>
                        <Divider orientation="center">
                           <Title level={5} style={{ textAlign: "Left", color: "#a3a3ac" }}>Enter Parameters</Title>
                        </Divider>

                     </>
               }
            </>
         }

         <Modal
            key="Modal-AI"
            title={<><Image src='../images/brainee_bot.png' preview={false} height="25px" /> Brainee AI Assessment Generator</>}
            // title="Brainee AI Assessment Generator"
            destroyOnClose={true}
            centered
            open={visibleAI}
            okButtonProps={{ style: { display: 'none' } }}
            cancelButtonProps={{ shape: 'round', type: 'primary', className: "button-shadow" }}
            onCancel={() => setVisibleAI(false)}
            cancelText="Close"
            width={"35%"}
            style={{ minWidth: "350px", maxWidth: "95%" }}
         // footer={false}
         >
            <Form
               // ref={formRef}
               form={form}
               layout={"vertical"}
               colon={false}
               className='aiform'
               onFinish={onFinish}
               onFinishFailed={onFinishFailed}
            >
               <SimpleBarReact key={'uid'} style={{ maxHeight: "calc(100vh - 217px)", width: '99%' }}>
                  <Form.Item name="subject" label="Subject"
                     rules={[{
                        required: true,
                        message: 'Subject should not be blank'
                     }]}
                     initialValue={props.data.Subject.toLowerCase()}
                  >
                     <Select
                        key={'uid'}
                        showArrow
                        size='large'
                        style={{ width: '100%' }}
                        allowClear
                        placeholder="Select subject"
                        disabled
                        value={props.data.Subject.toLowerCase()}
                     // defaultValue={'araling panlipunan'}
                     // onChange={(val) => setSubject(val)}
                     >
                        <Option value={'araling panlipunan'}>Araling Panlipunan</Option>
                        <Option value={'english'}>English</Option>
                        <Option value={'filipino'}>Filipino</Option>
                        <Option value={'mathematics'}>Mathematics</Option>
                        <Option value={'science'}>Science</Option>
                        <Option value={'technology and livelihood education'}>Technology and Livelihood Education</Option>
                     </Select>
                  </Form.Item>
                  <Form.Item name="gradelevel" label="Grade Level"
                     rules={[{
                        required: true,
                        message: 'Grade level should not be blank'
                     }]}
                     initialValue={props.data.Level.toLowerCase()}
                  >
                     <Select
                        key={'uid'}
                        showArrow
                        size='large'
                        style={{ width: '100%' }}
                        allowClear
                        placeholder="Select grade level"
                        disabled
                        value={props.data.Level.toLowerCase()}
                     >
                        <Option value={'kinder'}>Kinder</Option>
                        <Option value={'grade 1'}>Grade 1</Option>
                        <Option value={'grade 2'}>Grade 2</Option>
                        <Option value={'grade 3'}>Grade 3</Option>
                        <Option value={'grade 4'}>Grade 4</Option>
                        <Option value={'grade 5'}>Grade 5</Option>
                        <Option value={'grade 6'}>Grade 6</Option>
                        <Option value={'grade 7'}>Grade 7</Option>
                        <Option value={'grade 8'}>Grade 8</Option>
                        <Option value={'grade 9'}>Grade 9</Option>
                        <Option value={'grade 10'}>Grade 10</Option>
                        <Option value={'grade 11'}>Grade 11</Option>
                        <Option value={'grade 12'}>Grade 12</Option>
                     </Select>
                  </Form.Item>
                  <Form.Item name="topic" label="Topic"
                     rules={[{
                        required: true,
                        message: 'Topic should not be blank'
                     }]}
                  // initialValue={topic}
                  >
                     <Input
                        key={'uid'}
                        allowClear
                        size='large'
                        style={{ borderRadius: 7 }}
                        placeholder="Enter Topic"
                        onBlur={(event) => setTopic(event.target.value)}
                     // value={topic}
                     />
                  </Form.Item>
                  <Form.Item name="noi" label="Number of Items"
                     rules={[{
                        required: true,
                        message: 'Number of items should not be blank'
                     }]}
                     initialValue={noi}
                  >
                     <InputNumber
                        key={'uid'}
                        size='large'
                        style={{ borderRadius: 7, width: "100%" }}
                        // defaultValue={1}
                        min="1"
                        max='100'
                        onChange={(val) => setNOI(val)}
                     // value={noi}
                     />
                  </Form.Item>
                  <Form.Item name="toq" label="Type of Question/s"
                     rules={[{
                        required: true,
                        message: 'Type of question should not be blank'
                     }]}
                     initialValue={toq}
                  >
                     <Select
                        key={'uid'}
                        showArrow
                        size='large'
                        style={{ width: '100%' }}
                        allowClear
                        placeholder="Select type of question"
                        // defaultValue={'short answer'}
                        onChange={(val) => setTOQ(val)}
                        mode="multiple"
                     // value={toq}
                     >
                        <Option value={'questions with short answer (should be one to two words only)'}>Short Answer</Option>
                        <Option value={'questions with multiple choice'}>Mutiple Choice</Option>
                        <Option value={'questions answerable by true or false'}>True or False</Option>
                        {/* <Option value={'multiple answers'}>Multiple Answers</Option> */}
                        <Option value={'questions with multiple choice and should have more than 1 correct answer'}>Mutiple Answer</Option>
                        {/* <Option value={'open-ended, essay'}>Open-ended/Essay</Option> */}
                        {/* <Option value={'fill in the blank with choices'}>Fill in the Blank</Option> */}
                        {/* <Option value={'matching type'}>Matching Type</Option> */}
                     </Select>
                  </Form.Item>
                  <Form.Item name="lod" label="Level of Difficulty"
                     rules={[{
                        required: true,
                        message: 'Level of difficulty should not be blank'
                     }]}
                     initialValue={lod}
                  >
                     <Select
                        key={'uid'}
                        showArrow
                        size='large'
                        style={{ width: '100%' }}
                        allowClear
                        placeholder="Select difficulty level"
                        // defaultValue={'easy'}
                        onChange={(val) => setLOD(val)}
                     // value={lod}
                     >
                        <Option value={'easy'}>Easy</Option>
                        <Option value={'medium'}>Average</Option>
                        <Option value={'hard'}>Difficult</Option>
                     </Select>
                  </Form.Item>

                  <Form.Item name="translation" label="Translation"
                     rules={[{
                        required: true,
                        message: 'Translation should not be blank'
                     }]}
                     initialValue={language}
                  >
                     <Select
                        key={'uid'}
                        showArrow
                        size='large'
                        style={{ width: '100%' }}
                        allowClear
                        placeholder="Select translation"
                        // defaultValue={'english'}
                        onChange={(val) => setLanguage(val)}
                     // value={language}
                     >
                        <Option value={'english'}>English</Option>
                        <Option value={'tagalog'}>Filipino</Option>
                     </Select>
                  </Form.Item>
               </SimpleBarReact>

               {/* <Button className='button-shadow' size='middle' type="primary" shape='round' block loading={generating}
                  htmlType='submit'
               >
                  <AntDIcons.SendOutlined />Generate
               </Button> */}

               <Row gutter={[10, 10]} style={{ marginTop: "5px" }}>
                  <Col sm={24}>
                     {
                        generating
                           ?
                           <Button className='button-shadow' size='middle' type="primary" shape='round' block loading={generating}
                              htmlType='submit'
                           >
                              Generating...
                           </Button>
                           :
                           <Button className='button-shadow' size='middle' type="primary" shape='round' block loading={generating}
                              htmlType='submit'
                           >
                              <SendOutlined />Generate
                           </Button>
                     }

                  </Col>
                  {/* <Col sm={24} md={12} lg={12}>
                     <Button className='button-shadow' size='middle' type="primary" shape='round' block disabled={!generating} onClick={() => xhr?.abort()}>
                        Stop
                     </Button>
                  </Col> */}
               </Row>
            </Form>
         </Modal>

         <Modal
            key="modal-upload-assessment-tools"
            title={<div><Image src='../images/brainee_mascot.png' preview={false} height="30px" width="28px" /> Upload File</div>}
            destroyOnClose={true}
            centered
            open={isUploading}
            okButtonProps={{ style: { display: 'none' } }}
            cancelButtonProps={{ style: { display: 'none' } }}
         >
            <span>Uploading...</span>
            <Progress
               percent={percentage}
               status="active"
               strokeColor={{
                  '0%': '#5A98D2',
                  '100%': '#1b5596',
               }}
            />
         </Modal>

         <Modal
            key="Assessment-Details"
            title={<>Assessment Information</>}
            destroyOnClose={true}
            centered
            open={visibleAssessmentDetails}
            okButtonProps={{ style: { display: 'none' } }}
            cancelButtonProps={{ shape: 'round', type: 'primary', className: "button-shadow" }}
            onCancel={() => setVisibleAssessmentDetails(false)}
            onOk={() => setVisibleAssessmentDetails(false)}
            okText="Ok"
            cancelText="Close"
            // width={"35%"}
            // width={isMobile ? '100%' : "35%"}
            style={isMobile ? { top: 28, paddingBottom: 0 } : {width: "35%"}}
            className={isMobile ? 'cc-fullscreen-modal' : undefined}
         >
            <div style={{ textAlign: "center", display: "flex", flexWrap: "wrap", overflow: "auto", gap: "20px", justifyContent: 'space-between' }}>
               <Card style={{ backgroundColor: "#e0ecff", margin: "5px", width: "100%" }}>
                  <div style={{ display: "flex", flexDirection: "column", gap: "5px", marginBottom: "10px" }} onBlur={handleUpdateInfo}>
                     <span style={{ color: "#77777d", textAlign: "left", paddingLeft: "10px" }}>Title</span>
                     <Input
                        size='default'
                        style={{ width: '100%', textAlign: "left", borderRadius: "7px" }}
                        placeholder="Enter Title"
                        value={editableTitle}
                        onChange={(e) => { setEditableTitle(e.target.value) }}
                     />
                  </div>

                  <div style={{ display: "flex", flexDirection: "column", gap: "5px", marginBottom: "10px" }} >
                     <span style={{ color: "#77777d", textAlign: "left", paddingLeft: "10px" }}>Level</span>
                     <Select
                        showArrow
                        size='default'
                        style={{ width: '100%', textAlign: "left" }}
                        allowClear
                        placeholder="Select Level"
                        onChange={(val) => { handleLevelChange(val)}}
                        value={assLevel}
                     >
                        {Levels.map(({ value, name }, idx) => {
                           return <Option value={value}>{name}</Option>
                        })}
                     </Select>
                  </div>

                  <div style={{ display: "flex", flexDirection: "column", gap: "5px", marginBottom: "10px" }} onBlur={handleUpdateInfo}>
                     <span style={{ color: "#77777d", textAlign: "left", paddingLeft: "10px" }}>Subject</span>
                     <Select
                        showArrow
                        size='default'
                        style={{ width: '100%', textAlign: "left" }}
                        allowClear
                        placeholder="Select Subject"
                        onChange={(val) => { setAssSubject(val)}}
                        value={assSubject}
                     >
                        {subjectList.map(({ value, name }, idx) => {
                           return <Option value={value}>{name}</Option>
                        })}
                     </Select>
                  </div>

                  <div style={{ display: "flex", flexDirection: "column", gap: "5px", marginBottom: "10px" }} onBlur={handleUpdateInfo}>
                     <span style={{ color: "#77777d", textAlign: "left", paddingLeft: "10px" }}>Term</span>
                     <Select
                        showArrow
                        size='default'
                        style={{ width: '100%', textAlign: "left" }}
                        allowClear
                        placeholder="Select Term"
                        onChange={(val) => { setAssTerm(val)}}
                        value={assTerm}
                     >
                        {SchoolTerms.map(({ value, name }, idx) => {
                           return <Option value={value}>{name}</Option>
                        })}
                     </Select>
                  </div>
               </Card>
            </div>
         </Modal>

         <Modal
            key="Answer-Keys"
            title={<>Select Question Type</>}
            destroyOnClose={true}
            centered
            open={visibleAnswerKeys}
            okButtonProps={{ style: { display: 'none' } }}
            cancelButtonProps={{ shape: 'round', type: 'primary', className: "button-shadow" }}
            onCancel={() => setVisibleAnswerKeys(false)}
            onOk={() => setVisibleAnswerKeys(false)}
            okText="Ok"
            cancelText="Close"
            // width={"43%"}
            style={isMobile ? { top: 28, paddingBottom: 0, width: "100%" } : {width: "43%"}}
            className={isMobile ? 'cc-fullscreen-modal' : undefined}
         >
            <div style={{ maxHeight: isMobile ? "auto" : "calc(100vh - 350px)",  textAlign: "center", display: "flex", flexWrap: "wrap", overflow: "auto", gap: "20px" }}>
               <div onClick={() => handleCardRequest("add", "section", 0)}>
                  <Card hoverable={true} style={{ backgroundColor: '#d0e2fe', height: '121px', maxWidth: '202px', padding: '0px !important' }}>
                     <Text>Section</Text>
                     <img src='../images/section.png'></img>
                  </Card>
               </div>

               <div onClick={() => handleCardRequest("add", "short_answer", 0)}>
                  <Card hoverable={true} style={{ backgroundColor: '#d0e2fe', height: '121px', maxWidth: '202px', padding: '0px !important' }}>
                     <Text>Short Answer</Text>
                     <img src='../images/short_answer.png'></img>
                  </Card>
               </div>

               <div onClick={() => handleCardRequest("add", "true_or_false", 0)}>
                  <Card hoverable={true} style={{ backgroundColor: '#d0e2fe', height: '121px', maxWidth: '202px', padding: '0px !important' }}>
                     <Text>True or False</Text>
                     <img src='../images/true_or_false.png'></img>
                  </Card>
               </div>

               <div onClick={() => handleCardRequest("add", "long_answer", 0)}>
                  <Card hoverable={true} style={{ backgroundColor: '#d0e2fe', height: '121px', maxWidth: '202px' }}>
                     <Text>Open-ended/Essay</Text>
                     <img src='../images/essay.png'></img>
                  </Card>
               </div>

               <div onClick={() => handleCardRequest("add", "multiple_choice", 0)}>
                  <Card hoverable={true} style={{ backgroundColor: '#d0e2fe', height: '121px', maxWidth: '202px' }}>
                     <Text>Multiple Choice</Text>
                     <img src='../images/multiple_choice.png'></img>
                  </Card>
               </div>

               <div onClick={() => handleCardRequest("add", "multiple_choice_image", 0)}>
                  <Card hoverable={true} style={{ backgroundColor: '#d0e2fe', height: '121px', maxWidth: '202px' }}>
                     <Text>Multiple Choice - Image</Text>
                     <img src='../images/multiple_choice_image.png'></img>
                  </Card>
               </div>

               <div onClick={() => handleCardRequest("add", "multiple_answer", 0)}>
                  <Card hoverable={true} style={{ backgroundColor: '#d0e2fe', height: '121px', maxWidth: '202px' }}>
                     <Text>Multiple Answer</Text>
                     <img src='../images/multiple_answer.png'></img>
                  </Card>
               </div>

               <div onClick={() => handleCardRequest("add", "multiple_answer_image", 0)}>
                  <Card hoverable={true} style={{ backgroundColor: '#d0e2fe', height: '121px', maxWidth: '202px' }}>
                     <Text>Multiple Answer - Image</Text>
                     <img src='../images/multiple_answer_image.png'></img>
                  </Card>
               </div>

               <div onClick={() => handleCardRequest("add", "matching_type", 0)}>
                  <Card hoverable={true} style={{ backgroundColor: '#d0e2fe', height: '121px', maxWidth: '202px' }}>
                     <Text>Matching Type</Text>
                     <img src='../images/matching_type.png'></img>
                  </Card>
               </div>

               <div onClick={() => handleCardRequest("add", "matching_type_image", 0)}>
                  <Card hoverable={true} style={{ backgroundColor: '#d0e2fe', height: '121px', maxWidth: '202px' }}>
                     <Text>Matching Type - Image</Text>
                     <img src='../images/matching_type_image.png'></img>
                  </Card>
               </div>
            </div>
         </Modal>
      </div >
   )
}